import { render } from "./leads-details-sidebar.vue?vue&type=template&id=d66b991e&scoped=true"
import script from "./leads-details-sidebar.vue?vue&type=script&lang=js"
export * from "./leads-details-sidebar.vue?vue&type=script&lang=js"

import "./leads-details-sidebar.vue?vue&type=style&index=0&id=d66b991e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66b991e"]])

export default __exports__